import Game from "../Game";
import GameCore from "../GameCore";
import BaseBullet from "./BaseBullet";
import BaseWeapon from "./BaseWeapon";
import { BulletGroup } from "./BulletGroup";

export default class HashbladeBullet extends BaseBullet {
  previousArea: number;
  tween: Phaser.Tweens.Tween;
  tween2: Phaser.Tweens.Tween;

  constructor(
    group: BulletGroup,
    weapon: BaseWeapon,
    indexInWeapon = 0,
    x: number = 0,
    y: number = 0
  ) {
    super(
      group,
      weapon,
      indexInWeapon,
      "hashblade_single_0",
      x,
      y,
      "weapon_effects"
    );
    this.previousArea = 0;
  }

  Init(x = -1000, y = -1000) {
    super.Init(x, y);
    this.setScale(0);
    this.previousArea = this.weapon.PArea;
    this.play("hashblade_attack");
    this.tween = this.scene.tweens.add({
      targets: this,
      scaleY: 2 * GameCore.PixelScale * this.weapon.PArea,
      scaleX: 4 * GameCore.PixelScale * this.weapon.PArea,
      duration: 100,
      ease: "Linear",
      onComplete: () => {
        this.tween2 = this.scene.tweens.add({
          targets: this,
          alpha: 0,
          duration: 100,
          ease: "Linear",
          delay: 100,
          onComplete: () => {
            this.DeSpawn();
          },
        });
      },
    });
    if (this.body) {
      this.body.setSize(this.width * 0.8, this.height);
    }
  }

  OnRecycle() {
    super.OnRecycle();
    this.alpha = 1;

    // Reset and play animation
    this.play("hashblade_attack");

    // Clean up existing tweens
    if (this.tween?.parent) {
      this.tween.stop();
      this.scene.tweens.remove(this.tween);
    }
    if (this.tween2?.parent) {
      this.tween2.stop();
      this.scene.tweens.remove(this.tween2);
    }

    // Always create fresh tweens
    this.setScale(0);
    this.tween = this.scene.tweens.add({
      targets: this,
      scaleY: 2 * GameCore.PixelScale * this.weapon.PArea,
      scaleX: 4 * GameCore.PixelScale * this.weapon.PArea,
      duration: 100,
      ease: "Linear",
      onComplete: () => {
        this.tween2 = this.scene.tweens.add({
          targets: this,
          alpha: 0,
          duration: 100,
          ease: "Linear",
          delay: 100,
          onComplete: () => {
            this.DeSpawn();
          },
        });
      },
    });

    this.body?.setSize(this.width * 0.8, this.height);
    this.previousArea = this.weapon.PArea;

    const t = Game.Core.Player.flipX
      ? this.indexInWeapon % 2 !== 1
      : this.indexInWeapon % 2 === 1;
    this.x += t ? -65 : 65;
    this.y -= 16 * this.indexInWeapon;
    this.setFlipY(this.indexInWeapon % 2 == 1);
    this.setFlipX(t);
  }

  DeSpawn() {
    this.stop(); // Stop the animation
    super.DeSpawn();
  }
}
